// extracted by mini-css-extract-plugin
export default {"banner":"LowQualityWarningBanner-module__banner--MaH0h","buttonContent":"LowQualityWarningBanner-module__buttonContent--nBYt6"};